export default __webpack_public_path__ + "static/media/firebasepng.60bf6733.png";